import React, { useEffect } from 'react';
import BadgeDisplay from './BadgeDisplay';
import { BadgeType, BadgeTier } from '../utils/badges';
import { sound } from '../utils/sound';

interface NewBadge {
  type: BadgeType;
  tier: BadgeTier;
}

interface BadgePopupProps {
  badges: NewBadge[];
  onContinue: () => void;
  isClosing?: boolean;
}

const BadgePopup: React.FC<BadgePopupProps> = ({ badges, onContinue, isClosing = false }) => {
  // Play badge sound on mount
  useEffect(() => {
    sound.badge();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === 'Escape') {
        handleContinueClick();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onContinue]);

  const handleContinueClick = () => {
    sound.clickClose();
    onContinue();
  };

  return (
    <div className={`badge-popup-overlay ${isClosing ? 'closing' : ''}`}>
      <div className="badge-popup-wrapper">
        <div className={`badge-popup-content ${isClosing ? 'closing' : ''}`}>
          <div className="badge-popup-header">
            <h2>Badge{badges.length > 1 ? 's' : ''} Awarded</h2>
          </div>
          <div className="badge-popup-body">
            <div className="badge-popup-list">
              {badges.map((badge, index) => (
                <BadgeDisplay
                  key={`${badge.type}-${badge.tier}-${index}`}
                  type={badge.type}
                  tier={badge.tier}
                  animate={true}
                  showLabel={true}
                />
              ))}
            </div>
          </div>
        </div>
        <button className="badge-popup-continue" onClick={handleContinueClick}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default BadgePopup;
